'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var DeliveryIconColored = function (props) {
    var className = props.className;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '' });
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "currentColor" }, svgProps),
            React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2v13.999H0V7h5V2h9Zm1 13.999h5V11l-3-4h-2v8.999Z", fill: "currentColor" }),
            React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 3h4v1H0V3ZM1 5h3v1H1V5Z", fill: "currentColor" }),
            React__default['default'].createElement("mask", { id: "a", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "2", y: "13", width: "5", height: "5" },
                React__default['default'].createElement("circle", { cx: "4.5", cy: "15.5", r: "2.5", fill: "#C4C4C4" })),
            React__default['default'].createElement("g", { mask: "url(#a)" },
                React__default['default'].createElement("path", { fill: "#fff", d: "M2 13h5v3H2z" })),
            React__default['default'].createElement("mask", { id: "b", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "14", y: "13", width: "5", height: "5" },
                React__default['default'].createElement("circle", { cx: "16.5", cy: "15.5", r: "2.5", fill: "#C4C4C4" })),
            React__default['default'].createElement("g", { mask: "url(#b)" },
                React__default['default'].createElement("path", { fill: "#fff", d: "M14 13h5v3h-5z" })),
            React__default['default'].createElement("circle", { cx: "4.5", cy: "15.5", r: "1.5", fill: "currentColor" }),
            React__default['default'].createElement("circle", { cx: "16.5", cy: "15.5", r: "1.5", fill: "currentColor" }))));
};

exports.default = DeliveryIconColored;
//# sourceMappingURL=index.js.map
